import React from "react"
import OneBet from "./OneBet"
import styled from "styled-components"

export default function Table({ users }: any) {
  return (
    <Wrapper>
      {users.map((u: any) => (
        <OneBet
          key={u.id}
          name={u.name}
          bet={u.bet}
          currency={u.currency}
          cashout={u.cashout}
        />
      ))}
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow: hidden;
  height: 298px;
  padding: 4px 15px 0;
`
